var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useState } from 'react';
export function usePatchElement() {
    var _a = useState([]), elements = _a[0], setElements = _a[1];
    var patchElement = useCallback(function (element) {
        // Append a new element to elements (and create a new ref in other place)
        setElements(function (elements) { return __spreadArray(__spreadArray([], elements, true), [element], false); });
        // Return a fnction that removes the new element from elements
        // It works a little like `useEffect`
        return function () {
            setElements(function (elements) { return elements.filter(function (el) { return el !== element; }); });
        };
    }, []);
    return [elements, patchElement];
}
